export default __webpack_public_path__ + "static/media/felling.cf8ee9bd.jpg";